module.exports = __webpack_public_path__ + "img/fourteen.8c87b9c2.png";